<div class="card-body">
    <h5 class="card-title">Application logs overview</h5>
    <div *ngIf="listObservable | async as data; else loading">
        <dx-data-grid [dataSource]="data" [allowColumnResizing]="true" [allowColumnReordering]="true" [wordWrapEnabled]="true" (onRowPrepared)="onRowPrepared($event)" height="calc(100vh - 320px)">
          <dxo-selection mode="none"></dxo-selection>
          <dxo-filter-row [visible]="true"></dxo-filter-row>

          <dxi-column dataField="logged" width="120px" dataType="date" format="yyyy-MM-dd HH:mm:ss" [sortIndex]="1" sortOrder="desc"></dxi-column>
          <dxi-column dataField="level" width="50px"></dxi-column>
          <dxi-column dataField="message" cellTemplate="copyIconTemplate"></dxi-column>
          <dxi-column dataField="logger"></dxi-column>
          <dxi-column dataField="properties" [visible]="false"></dxi-column>
          <dxi-column dataField="callSite" [visible]="false"></dxi-column>
          <dxi-column dataField="exception" cellTemplate="copyIconTemplate"></dxi-column>

          <div class="copy-cell" *dxTemplate="let d of 'copyIconTemplate'">
            <span class="copy-icon"><i class="far fa-copy" (click)="copyContents(d)"></i></span>
            <span class="copy-text" [title]="d.value">{{d.value}}</span>
          </div>
        </dx-data-grid>
    </div>
    <ng-template #loading>Loading....</ng-template>
</div>
